import React, { useRef, useEffect } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

const AnimatedWrapper = ({ children, className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();
  const slideControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
      slideControls.start("visible");
    }
  }, [isInView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={mainControls}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.25, delay: 0.25 }}
      className={`relative`}
    >
      <div className={className}>{children}</div>
    </motion.div>
  );
};

const createAnimatedTypographyComponent = (Tag, defaultClass) => {
  return ({ children, className = "" }) => (
    <AnimatedWrapper className={`${defaultClass} ${className}`}>
      <Tag>{children}</Tag>
    </AnimatedWrapper>
  );
};

const Typography = {
  T: createAnimatedTypographyComponent(
    "h1",
    "max-xsm:text-[38px] max-md:text-[40px] max-lg:text-[50px] text-[77px] font-[500] font-primary leading-[110%]"
  ),
  Subt: createAnimatedTypographyComponent(
    "h2",
    "max-xsm:text-[26px] max-md:text-[36px] max-lg:text-[42px] text-[56px] font-[500] font-primary leading-[110%]"
  ),
  SmTit: createAnimatedTypographyComponent(
    "h3",
    "max-xsm:text-[18px] max-md:text-[22px] max-lg:text-[26px] text-[34px] font-[500] font-primary leading-[110%]"
  ),
  BoxName: createAnimatedTypographyComponent(
    "h3",
    "max-xsm:text-[16px] max-md:text-[18px] max-lg:text-[20px] text-[26px] font-[600] font-primary leading-[110%]"
  ),
  P: createAnimatedTypographyComponent(
    "p",
    "max-xsm:text-[14px] max-md:text-[15px] max-lg:text-[16px] text-[18px] font-[400] font-primary leading-[130%]"
  ),
  Smp: createAnimatedTypographyComponent(
    "p",
    "text-[14px] font-[500] font-primary leading-[130%]"
  ),
};

export default Typography;
